import { useMutation, useQueryClient } from "@tanstack/react-query";
import { syncSurveysWithTemplate } from ".";

export function useSyncSurveysWithTemplate() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: syncSurveysWithTemplate,
    mutationKey: ['survey','sync'],
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['survey'], exact: false });
    }
  });
}